import { colorSets, styled } from '@lessonup/ui-components';
import React from 'react';

interface PinComponentPlaceholderProps extends React.PropsWithChildren {
  style?: React.CSSProperties;
  onDoubleClick?(): void;
}

export const PinComponentPlaceholder: React.FC<PinComponentPlaceholderProps> = ({ style, onDoubleClick, children }) => {
  return (
    <StyledPinComponentPlaceholder style={style} onDoubleClick={onDoubleClick}>
      {children}
    </StyledPinComponentPlaceholder>
  );
};

const StyledPinComponentPlaceholder = styled.div`
  background: #dfe0e2;
  color: ${colorSets.neutral.onSubjacent};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  border: 2px dashed #bababa;
`;
